export default "/images/general.png?fcf18a00f0e307056c3a99c59cfca3e2";